<template>
    <div>
        <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
            <div class="single container-max page-content">
                <slot name="breadcrumb"></slot>
                <div class="row position-relative mt-5 single-item__top-container">

                    <div class="col-12 col-md-6 carousel-wrapper" :class="{'carousel-opacity': currentVariation.item.free4 == '1'}">
                        <div class="single__freetext-14 mb10" v-html="currentVariation.item.free14"></div>
                        <slot name="image-carousel"></slot>
                    </div>

                    <div class="col-12 col-md-5 offset-md-1 single-rightside my-3">
                        <div v-stick-in-parent data-sticky-container=".single-item__top-container">
                        <!-- START SINGLEITEM_DETAILS -->
                        <h1 class="h2 title">
                                <span>
                                    {{ currentVariation | itemName }}
                                </span>
                        </h1>

                        <div class="row align-items-center flex-md-row-reverse">

                            <div class="col-12 col-md-5 col-lg-6 producertag h6 producer text-muted" v-if="currentVariation.filter.hasManufacturer">
                                <div v-if="currentVariation.item.manufacturer.logo" class="single-item__producer-container">
                                    <img :src="currentVariation.item.manufacturer.logo" :alt="currentVariation.item.manufacturer.externalName">
                                </div>
                                <div v-else class="single-item__producer-container producer-no-image">
                                    {{ currentVariation.item.manufacturer.externalName }}
                                </div>
                            </div>

                            <div class="col-12 col-md-7 col-lg-6">
                                <div v-if="currentVariation.variation.availability" class="single__availability">
                                    <div class="single__availability-indicator" :class="'single__availability-indicator--' + currentVariation.variation.availability.id"></div><div>{{ currentVariation.variation.availability.names.name }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="row single-item__top-info">
                            <div class="col-lg-12 col-md-12">
                                <div class="hidden-xs-down">
                                    <div class="col-lg-6 col-md-6">
                                        <ul>
                                            <li v-for="(prop, index) in currentVariation.properties">{{ prop.property.names.name }}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="hidden-sm-up">
                                    <div class="col-lg-6 col-md-6">
                                        <p v-if="currentVariation.properties.length" class="toggle-single-item-info-mobile">Artikel-Eigenschaften <i class="fa fa-chevron-down single-item__top-info--mobile-icon"></i></p>
                                        <ul class="single-item__top-info--mobile">
                                            <li v-for="(prop, index) in currentVariation.properties">{{ prop.property.names.name }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <slot name="before-price"></slot>

                        <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                            <order-property-list></order-property-list>
                        </div>

                        <graduated-prices></graduated-prices>

                        <item-price :show-cross-price="isRecommendedPriceActive"></item-price>

                        <slot name="after-price"></slot>

                        <div class="row my-3">
                            <div class="w-100">
                                <div class="single__freetext-4" v-html="currentVariation.item.free4">
                                </div>
                                <slot name="before-add-to-basket"></slot>
                            </div>

                            <div class="w-100 add-to-basket-outer" :class="{'hide-btn-qty': currentVariation.item.free4 == '1'}">
                                <add-to-basket
                                        :variation-id="currentVariation.variation.id"
                                        :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                                        :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                                        :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                                        :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                                        :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                                        :order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
																				:has-order-properties="currentVariation.hasOrderProperties"
																				:has-required-order-property="currentVariation.hasRequiredOrderProperty"
																				:use-large-scale="false"
                                        :show-quantity="true"
                                        :item-url="currentVariation | itemURL"
                                        :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                                        :has-price="currentVariation | hasItemDefaultPrice"
                                >
                                </add-to-basket>
                            </div>

                            <div class="w-100">
                                <slot name="after-add-to-basket"></slot>
                            </div>
                        </div>

                        <slot name="additional-content-after-add-to-basket"></slot>

                        <div v-if="isWishListEnabled" class="row">
                            <div class="col-12">
                                <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
                            </div>
                        </div>
                        <!-- ./ITEM DETAIL -->

                        <!--<span class="vat small text-muted">
                                * <template v-if="showNetPrices">{{ $translate("Ceres::Template.singleItemExclVAT") }}</template><template v-else>{{ $translate("Ceres::Template.singleItemInclVAT") }}</template> {{ $translate("Ceres::Template.singleItemExclusive") }}
                            <a v-if="hasShippingCostsCategoryId" data-toggle="modal" href="#shippingscosts" :title="$translate('Ceres::Template.singleItemShippingCosts')">{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>
                            <a v-else :title="$translate('Ceres::Template.singleItemShippingCosts')">{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>

                            </span>

                        <slot name="additional-content-after-vat"></slot>-->
                        <!-- END SINGLEITEM_DETAILS -->

                        <table class="table single-item__description-container--right-info">
                            <tbody>
                            <tr>
                                <td><b>{{ $translate("Ceres::Template.singleItemId") }}</b></td>
                                <td>{{ currentVariation.variation.number }}</td>
                            </tr>

                            <tr v-if="currentVariation.filter.hasManufacturer && currentVariation.item.manufacturer.externalName !== ''">
                                <td><b>{{ $translate("Ceres::Template.singleItemManufacturer") }}</b></td>
                                <td>{{ currentVariation.item.manufacturer.externalName }}</td>
                            </tr>

                            <tr v-if="typeof currentVariation.barcodes !== 'undefined'">
                                <td><b>EAN</b></td>
                                <td>{{ currentVariation.barcodes[0].code }}</td>
                            </tr>
                            <tr v-if="currentVariation.variation.model !== ''">
                                <td><b>{{ $translate("Ceres::Template.singleItemModel") }}</b></td>
                                <td>{{ currentVariation.variation.model }}</td>
                            </tr>
                            <tr v-if="currentVariation.variation.weightG !== ''">
                                <td><b>Versandgewicht</b></td>
                                <td>{{ currentVariation.variation.weightG }} g</td>
                            </tr>
                            <tr v-if="currentVariation.variation.weightNetG !== ''">
                                <td><b>Inhalt</b></td>
                                <td>{{ currentVariation.unit.content }} {{ currentVariation.unit.names.name }}</td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>

                    <div class="single-item__description-container col-md-7">
                        <div class="my-5">
                            <ul class="nav nav-tabs d-none d-md-flex" role="tablist">
                                <li class="nav-item" v-if="isDescriptionTabActive">
                                    <a class="nav-link active" data-toggle="tab" :href="'#details-' + currentVariation.variation.id" role="tab">Beschreibung</a>
                                </li>

                                <li class="nav-item" v-if="isTechnicalDataTabActive">
                                    <a :class="{ 'active': !isDescriptionTabActive && isTechnicalDataTabActive }" class="nav-link" data-toggle="tab" :href="'#data-' + currentVariation.variation.id" role="tab">Zutaten / Nährwerte</a>
                                </li>

                                <slot name="add-detail-tabs"></slot>
                            </ul>

                            <div class="tab-content overflow-hidden">
                                <ul class="nav nav-tabs d-block d-md-none " role="tablist">
                                    <li class="nav-item" v-if="isDescriptionTabActive">
                                        <a class="nav-link active nav-link--inner" data-toggle="tab" :href="'#details-' +  currentVariation.variation.id" role="tab">Beschreibung</a>
                                    </li>
                                </ul>
                                <div class="tab-pane active overflow-auto" :id="'details-' + currentVariation.variation.id" role="tabpanel" v-if="isDescriptionTabActive">
                                    <div class="my-4 pl-md-0 col-12" v-html="currentVariation.texts.description">
                                    </div>
                                </div>

                                <ul class="nav nav-tabs d-block d-md-none" role="tablist">
                                    <li class="nav-item">
                                        <a :class="{ 'active': !isDescriptionTabActive && isTechnicalDataTabActive }" class="nav-link nav-link--inner" data-toggle="tab" :href="'#data-' + currentVariation.variation.id" role="tab">Zutaten / Nährwerte</a>
                                    </li>
                                </ul>
                                <div :class="{ 'active': !isDescriptionTabActive && isTechnicalDataTabActive }" class="tab-pane overflow-auto" :id="'data-' + currentVariation.variation.id" role="tabpanel" v-if="isTechnicalDataTabActive">
                                    <div class="my-4 pl-md-0 col-12" v-html="currentVariation.texts.technicalData">
                                    </div>
                                </div>
                                <slot name="add-detail-tabs-content"></slot>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="single__crossselling">
                    <slot name="item-list-container"></slot>
                </div>

                <slot name="feedback-container"></slot>
            </div>
        </slot>
    </div>
</template>

<script>
import { get } from "ceres/app/helper/get";
import { isNullOrUndefined } from "ceres/app/helper/utils";

export default {

    name: "single-item",

    props: {
        pleaseSelectOptionVariationId: {
            type: Number,
            default: 0
        },
        initPleaseSelectOption: {
            type: Boolean,
            default: false
        },
        showNetPrices: {
            type: Boolean,
            default: false
        },
        isWishListEnabled: {
            type: Boolean,
            default: false
        },
        itemId: {
            type: Number,
            required: true
        },
        afterKey: Object
    },

    jsonDataFields: [
        "itemData",
        "attributesData",
        "variations"
    ],

    provide()
    {
        return {
            itemId: this.$props.itemId
        }
    },

    computed:
    {
        itemConfig()
        {
            return App.config.item.itemData;
        },

        isDescriptionTabActive()
        {
            return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.description.length;
        },

        isRecommendedPriceActive()
        {
            return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
        },

        isShortDescriptionActive()
        {
            return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
        },

        hasShippingCostsCategoryId()
        {
            return App.config.global.shippingCostsCategoryId > 0;
        },

        isTechnicalDataTabActive()
        {
            return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.technicalData.length;
        },

        variationGroupedProperties()
        {
            return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
        },

        variationMissingProperties()
        {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        currentVariation() {
            return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
        },

        isVariationSelected() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
        },

        attributes() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
        },

        units() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
        },

        isItemSet() {
            return this.$store.state.items.isItemSet;
        }
    },

    created()
    {
        this.$store.dispatch("initVariation", this.itemData);
        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
                itemId:             this.itemId,
                attributes:         this.attributesData,
                variations:         this.variations,
                initialVariationId: this.currentVariation.variation.id,
                isPleaseSelectOption: this.initPleaseSelectOption,
                afterKey:           this.afterKey
            });

          if (this.isItemSet)
          {
            this.$store.dispatch("initSetComponents", this.itemData);
          }

          console.log(this.currentVariation.item.free4)

          if(this.currentVariation.item.free4 == "1"){
            $('.carousel-wrapper').addClass("carousel-opacity");
            //$('.single-carousel .owl-stage').css('opacity', '0.4');
            $('.add-to-basket-outer').addClass("hide-btn-qty");
            //$('.single-rightside .add-to-basket-container .article-card__btn').attr('disabled', true);
          }

          if(this.currentVariation.item.free14 == 0 || this.currentVariation.item.free14 == '' || this.currentVariation.item.free14 == null){
            $('.single__freetext-14').hide();
          }else{
            //$('.quantity-input-container').hide();
            //$('.add-to-basket-container .article-card__btn').hide();
            //$('.merkliste-btn').css('marginLeft', 0);
            $('.add-to-basket-outer').addClass("hide-btn-qty");
          }

          $(document).on("click", ".nav-link--inner", function (ev) {
            ev.preventDefault();

            var target = $(this).attr("href");
            $(".nav-link--inner").removeClass("show active");
            $(this).addClass("show active");
          });
        })

      // listen for variation change to hydrate all children lazy-hydrate components
      document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
    },

    methods:
    {
        getDataField(field)
        {
            return get(this.currentVariation, field);
        },

        getFilteredDataField(field, filter)
        {
            if (!isNullOrUndefined(this.$options.filters[filter]))
            {
                return this.$options.filters[filter](this.getDataField(field));
            }

            return this.getDataField(field);
        },

        // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
        hydrateChildren(nodes)
        {
            nodes.forEach(component => {
                if (component.$options.name === "lazy-hydrate")
                {
                    component.hydrate();
                }
                else if (component.$children.length)
                {
                    this.hydrateChildren(component.$children);
                }
            })
        }
    }
}
</script>
